import React, {Component} from 'react';
export default class NotFound extends Component{
    render(){
        return <div>
            Khong tim thay trang
        </div>
    }
}


// WEBPACK FOOTER //
// ./src/components/notFound.js